import { useEffect, useState } from 'react'

const openingLogo = '/modi-cafe-logo.png'

export function OpeningAnimation() {
  const [isVisible, setIsVisible] = useState(true)
  const [isLeaving, setIsLeaving] = useState(false)

  useEffect(() => {
    if (!isVisible) return

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    const leaveDelay = prefersReducedMotion ? 250 : 850
    const removeDelay = prefersReducedMotion ? 420 : 1250
    const leaveTimer = window.setTimeout(() => {
      setIsLeaving(true)
    }, leaveDelay)
    const removeTimer = window.setTimeout(() => {
      setIsVisible(false)
    }, removeDelay)

    return () => {
      window.clearTimeout(leaveTimer)
      window.clearTimeout(removeTimer)
    }
  }, [isVisible])

  if (!isVisible) return null

  return (
    <div className={`opening-animation${isLeaving ? ' is-leaving' : ''}`} aria-hidden="true">
      <div className="opening-animation-mark">
        <span className="opening-line opening-line-top" />
        <img
          alt=""
          decoding="async"
          fetchPriority="high"
          height="320"
          src={openingLogo}
          width="600"
        />
        <span className="opening-line opening-line-bottom" />
      </div>
      <div className="opening-animation-caption">
        <span>Modi Cafe</span>
        <strong>Kahvalti & Cafe</strong>
      </div>
    </div>
  )
}
